import { useToken } from "@gluestack-style/react";
import BudgetProgress from "components/general/BudgetProgress";
import { Box, HStack, Text, Typography } from "components/ui";
import { ListTree, MapPin, MapPinned, Pin, PinIcon } from "lucide-react-native";
import React from "react";
import { Col, Row } from "react-native-flex-grid";

type Props = {
	data: {
		groupName?: string;
		name?: string;
		suburb?: string;
		id?: string;
	};
	isOnSearch?: boolean;
	styleData?: any;
	isMegaMenu?: boolean;
};

const SiteItem = ({ data, styleData, isOnSearch, isMegaMenu }: Props) => {
	const resolvedPrimarylight = useToken("colors", "primarylight");

	if (isOnSearch) {
		return (
			<Row style={styleData} key={data.id}>
				<Col style={{ justifyContent: "center" }}>
					<HStack gap={8} alignItems="center">
						<MapPin size={24} color={resolvedPrimarylight} />
						<Text sx={{ fontFamily: "Roboto_700Bold" }}>
							{data.groupName} - {data.suburb}
						</Text>
					</HStack>
				</Col>
			</Row>
		);
	}
	if (isMegaMenu) {
		return (
			<Row style={styleData} key={data.id}>
				<Col style={{ justifyContent: "center" }}>
					<HStack gap={8}>
						{/* <ListTree style={{ width: 24, height: 24 }} size={24} color={resolvedPrimarylight} /> */}
						<MapPin color="white" />
						<Typography underline color="$basicwhite">
							{data.name}
						</Typography>
					</HStack>
				</Col>
			</Row>
		);
	}
	return (
		<Row style={styleData} key={data.id}>
			<Col style={{ justifyContent: "center" }} xs={4} md={2}>
				<HStack gap={8}>
					<ListTree style={{ width: 24, height: 24 }} size={24} color={resolvedPrimarylight} />
					<Text numberOfLines={1}>{data.groupName}</Text>
				</HStack>
			</Col>
			<Col style={{ justifyContent: "center" }} xs={4} md={4}>
				<HStack gap={8}>
					<MapPinned style={{ flex: 1, maxWidth: 24 }} width={24} color={resolvedPrimarylight} />
					<Text flex={1}>{data.name}</Text>
				</HStack>
			</Col>
			<Col style={{ justifyContent: "center" }} xs={3} md={3}>
				<HStack gap={8} alignItems="center">
					<MapPin size={24} color={resolvedPrimarylight} />
					<Text>{data.suburb}</Text>
				</HStack>
			</Col>
			{/* <Col style={{ justifyContent: "center" }} xs={3} md={3}>
				<HStack gap={8} alignItems="center">
					<Box marginLeft={"auto"}>
						<BudgetProgress currentBudget={938} totalBudget={3000} />
					</Box>
				</HStack>
			</Col> */}
		</Row>
	);
};

export default SiteItem;
